<template>
    <v-expansion-panel-content>
        <template v-slot:header>
            <v-card-title class="justify-space-between py-0 px-0">
                <div>
                    <v-btn @click="moveUpAnswer({questionIndex, index})" :disabled="index === 0" icon>
                        <v-icon>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn @click="moveDownAnswer({questionIndex, index})" :disabled="index === question.answers.length - 1" icon>
                        <v-icon>mdi-arrow-down</v-icon>
                    </v-btn>
                    <span>{{ index + 1 }}. Réponse: {{text}}</span>
                </div>
            </v-card-title>
        </template>
        <v-card class="mt-3 mb-3">
            <v-card-text>
                <v-layout row class="align-items-center">
                    <v-text-field
                        v-model="text"
                        label="Réponse"
                        :rules="answerRules"
                    ></v-text-field>
                    <SurveyClipboardButton :text-original="textOriginal"/>
                </v-layout>
                <v-layout row class="align-items-center">
                    <v-textarea
                        v-model="remarks"
                        label="Remarques"
                    ></v-textarea>
                    <SurveyClipboardButton :text-original="remarksOriginal"/>
                </v-layout>

                <v-text-field
                    type="number"
                    v-model="value"
                    :rules="valueRules"
                    label="Valeur (nombre seulement)"
                >
                </v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" v-if="question.can.delete" @click="removeAnswer(questionIndex, index)">Supprimer</v-btn>
            </v-card-actions>
        </v-card>
    </v-expansion-panel-content>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import SurveyClipboardButton from "./components/SurveyClipboardButton.vue";

export default {
    name: "SurveyAnswerForm",
    components: {SurveyClipboardButton},
    data: () => ({
        answerRules: [
            v => !!v || 'Réponse est requise',
        ],
        valueRules: [
            // can be 0
            v => v !== null || 'Valeur est requise',
            v => v !== undefined || 'Valeur est requise',
            v => v !== '' || 'Valeur est requise',
            v => !isNaN(v) || 'Valeur doit être un nombre',
        ],
    }),
    props: {
        questionIndex: {
            type: Number,
        },
        answer: {
            type: Object,
        },
        index: {
            type: Number,
        }
    },

    computed: {
        text: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.questionIndex].answers[this.index].text
            },
            set(text) {
                this.setText({questionIndex: this.questionIndex, index: this.index, text})
            },
        },
        textOriginal() {
            return this.$store.state.surveys.form_group.questions[this.questionIndex].answers[this.index].textOriginal
        },
        remarks: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.questionIndex].answers[this.index].remarks
            },
            set(remarks) {
                this.setRemarks({questionIndex: this.questionIndex, index: this.index, remarks})
            },
        },
        remarksOriginal() {
            return this.$store.state.surveys.form_group.questions[this.questionIndex].answers[this.index].remarksOriginal
        },
        value: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.questionIndex].answers[this.index].value
            },
            set(value) {
                this.setValue({questionIndex: this.questionIndex, index: this.index, value})
            },
        },
        question: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.questionIndex]
            },
        },
    },
    methods:{
        ...mapMutations('surveys', {
            setText: 'setFormAnswerText',
            setRemarks: 'setFormAnswerRemarks',
            setValue: 'setFormAnswerValue',
            moveUpAnswer: 'moveUpAnswer',
            moveDownAnswer: 'moveDownAnswer',
        }),
        ...mapActions('surveys', [
            'addNewAnswer',
            'removeAnswer'
        ]),
    }
}
</script>

